<template>
    <div class="anchor-settings">

        <!-- settings group: CONTENT -->
        <div class="settings-group-title">
            <h6>Anchor settings</h6>
        </div>

        <!-- anchor name -->
        <div class="setting">
            <b-form-group>

                <label for="anchorname-text-input">Anchor name:  <span v-b-tooltip.hover.top title="Use a unique name that does not start with a number and does not contain any special characters, do also not use spaces."><i class="far fa-question-circle"></i></span></label>

                <b-form-input id="anchorname-text-input" type="text" v-model="settingsFromWeebly.settings.anchorName" @input="isAlpha()" size="sm" />

            </b-form-group>

            <div v-if="errorInString" class="errordisplay">
                <h2>Erroneous Anchor name</h2>
                Please fix the anchor name.<br>
                Anchor name can not have any:<br>
                <span>spaces, special characters or numeric values.</span>
            </div>
        </div>

        <!-- domain url -->
        <div class="setting">
            <b-form-group>

                <label for="anchorname-text-input">URL:  <span v-b-tooltip.hover.top title="Grab the url from the address bar of the page the anchor was added to."><i class="far fa-question-circle"></i></span></label>

                <b-form-input id="anchorname-text-input" type="text" v-model="settingsFromWeebly.settings.url" size="sm" />

            </b-form-group>
        </div>

    </div>
</template>

<script>

export default {

    name: 'AnchorSettings',

    data() {
        return {
            errorInString: false
        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        }

    },

    mounted() {

    },

    components: {

    },

    methods: {
        isAlpha() {
            console.log(event.target.value)
            let yourString = event.target.value
            if(/^[a-zA-Z()]+$/.test(event.target.value)){
                console.log('we are good')
                this.errorInString = false
            } else {
                console.log('characater can not be used')
                this.errorInString = true
                // return event.target.value = /^[a-zA-Z()]+$/.test(event.target.value)
            }

        }
    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';
.errordisplay {
    border: 1px solid @warning_red;
    font-size: 12px;
    padding: 7px;
    font-weight: 700;
    border-radius: .25rem;
    margin: 7px auto;

    h2 {
        font-size: 14px;
    }

    span {
        font-style: italic;
        display: block;
        margin-top: 7px;
        color: @warning_red;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/AnchorSettings.vue